import { observer, inject } from 'mobx-react';
import { useEffect, useState } from 'react';
import { Progress } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import $ from 'jquery';
import './UploadingTools.css';

function UploadingTools(Props) {
  //const contextRef = createRef();
  const { state } = Props;
  const [statusText, setStatusText] = useState('');
  const [isOpenUploadModule, setUploadModule] = useState(false);
  const { t } = useTranslation();
  const {
    updateScanningStatus,
    uploadingProgressArray,
    isOpenNewScan,
    uploadedFrontIds,
    initFrontId
  } = state.report;
  const uploadingData = uploadingProgressArray.slice();
  const uploadedData = uploadedFrontIds.slice();

  let count = 0;
  let mixedCount = 0;
  let updateInterval = null;

  if (uploadingData.length === 0) {
    count = 0;
  } else {
    uploadingData.map((item, idx) => {
      if (idx === 0) {
        mixedCount = item.status;
        return mixedCount;
      }
      mixedCount += item.status;
      return mixedCount;
    });
    count = Math.round(mixedCount / uploadingData.length);
  }

  const updateText = () => {
    if (count === 100) {
      setTimeout(setStatusText(t('modal.title.prepare_to_scan')), 3000);
    } else {
      setStatusText(t('modal.title.uploading'));
    }
  };

  const tick = (obj) => {
    return setTimeout(() => {
      updateScanningStatus(obj);
    }, 6000);
  };

  const checkModule = () => {
    if (uploadingData.length !== 0 && !isOpenNewScan) {
      const completeUpload = uploadingData.filter((item) => {
        return item.status !== 100;
      });

      if (completeUpload.length !== 0) {
        setUploadModule(true);
      }
    }

    const urlUploads = uploadingData.filter((item) => {
      return item.type === 'url' && item.status !== 100;
    });

    if (urlUploads.length !== 0) {
      const frontIds = urlUploads.map((item) => {
        return item.frontId;
      });
      const obj = {
        front_ids: frontIds,
        limit: '',
        page: 1
      };

      tick(obj);
      return clearTimeout(tick);
    }

    const filteredData = uploadingData.filter((item) => {
      return uploadedData.indexOf(item.frontId) !== -1;
    });

    if (isOpenUploadModule && (filteredData.length === uploadingData.length)) {
      setUploadModule(false);
      initFrontId();

      clearInterval(updateInterval);
      updateInterval = null;
    }
  };

  useEffect(() => {
    const $uploadEle = $('.upload_status');

    $(document).on('scroll', () => {
      $uploadEle.show();
      $uploadEle.css('opacity', 0.7);
    });
    if (uploadingData.length !== 0 && !isOpenNewScan) {
      updateText();
    }
    checkModule();
  });

  return (
    <div className="upload_status">
      {
        isOpenUploadModule
        && (
          <Progress
            className=""
            size="small"
            progress="percent"
            percent={count}
            indicating
          >
            {statusText}
          </Progress>
        )
      }
    </div>
  );
}

export default inject('state')(observer(UploadingTools));
